import { render } from "./Art-collection.vue?vue&type=template&id=2181c514"
import script from "./Art-collection.vue?vue&type=script&lang=js"
export * from "./Art-collection.vue?vue&type=script&lang=js"

import "./Art-collection.vue?vue&type=style&index=0&id=2181c514&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__